'use client';
import { Typography as LegacyTypography } from '@/components/typography';
import classNames from 'classnames';

import { DeveloperBadge } from './developers';
import styles from './developersHero.module.scss';

export const CardBadge = ({ badge }: { badge: DeveloperBadge }) => {
  const isAvailability = badge.type === 'availability';
  const label = isAvailability ? badge.label ?? 'Beschikbaar' : badge.label;

  return (
    <span
      className={classNames(
        styles.cardBadge,
        isAvailability && styles.cardBadgeAvailable
      )}
    >
      {isAvailability && <span className={styles.cardBadgeDot} aria-hidden />}
      <LegacyTypography tag="span" variant="label-small">
        {label}
      </LegacyTypography>
    </span>
  );
};
